export default __webpack_public_path__ + "static/media/user.2f899a2f.png";